module.exports = __webpack_public_path__ + "img/ssb_logo4_small.0ed4ab2d.png";